export default "__VITE_ASSET__D96jxScN__"